import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { FilterPill } from '../FilterPill/FilterPill';
import { useOverlay } from '../overlay/OverlayContext';

export const OnlineAppointmentsFilter = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();

  const handleClick = () => {
    setFilters({
      ...filters,
      onlineAppointments: filters.onlineAppointments ? undefined : {},
    });

    clear();
  };

  return (
    <FilterPill
      trackingId={LinkId.FILTER_BY_ONLINE_APPOINTMENTS_BUTTON}
      onClick={handleClick}
      hasValue={filters.onlineAppointments !== undefined}
    >
      Book online
    </FilterPill>
  );
};
